import * as pc from "playcanvas";
export var getBoundingBox = function (entity) {
    var bbox = new pc.BoundingBox();
    var hasCopiedBBox = false;
    var recursiveFillBBox = function (entity) {
        if (entity.model && entity.model.meshInstances && entity.enabled) {
            entity.model.meshInstances.forEach(function (meshInstance) {
                if (!hasCopiedBBox) {
                    bbox.copy(meshInstance.aabb);
                    hasCopiedBBox = true;
                }
                else {
                    bbox.add(meshInstance.aabb);
                }
            });
        }
        entity.children.forEach(function (child) { return recursiveFillBBox(child); });
    };
    recursiveFillBBox(entity);
    return hasCopiedBBox ? bbox : undefined;
};
